export class ContactTable {
    code: number;
    contactPosition: string;
    fullName: string;
    phone: string;
    status?: boolean;

    constructor() {
        this.code = 0;
        this.contactPosition = "";
        this.fullName = "";
        this.phone = "";
    }
}